import { Domains } from 'monitoring/constants/domains'
import { sendError } from 'monitoring/sendError/server/sendError'
import type { PageParams } from 'types/pageParams'
import { StatusCode } from 'types/statusCodes'
import { getHeaderAkamai } from 'utils/akamai'
import { getAkamaiFF } from 'utils/akamai/getAkamaiFF'
import { env } from 'utils/envManager'

import type { Product } from '../../types'

export interface GetProductInfoProps {
	productId: Product['id']
	country: PageParams['country']
	language: PageParams['language']
	enabled?: boolean
}

export async function getProductInfo(
	params: GetProductInfoProps,
	url: URL
): Promise<Product | null> {
	const { productId, language, country } = params
	const { orchestrator: orchestratorFromAkamai } = getAkamaiFF()

	const searchParams = new URLSearchParams({
		countryIso: country,
		channelId: env.NEXT_PUBLIC_CHANNEL,
		language,
	})

	url.search = searchParams.toString()

	let headers = {}
	if (orchestratorFromAkamai) {
		headers = await getHeaderAkamai()
	}
	const response = await fetch(url.href, {
		headers,
		next: {
			revalidate: 0,
		},
	})

	if (response.ok) {
		const product: Product = await response.json()

		return {
			...product,
			id: productId,
		}
	} else if (response.status === StatusCode.NOT_FOUND) {
		return null
	} else {
		throw sendError({
			message: '[ProductInfo] Failed to fetch product info',
			domain: Domains.Product,
			custom: {
				productId,
			},
		})
	}
}
